export const GET_LOGGED_IN_USER_DETAILS_ACTION =
    '[user details action] get logged in user details';

export function getLoggedInUserDetailsAction(data) {
    return {
        type: GET_LOGGED_IN_USER_DETAILS_ACTION,
        payload: data,
    };
}
